/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal, HelpBlock } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import OzTabs from '../lib/OzTabs';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, addUrlParam, getParams } from '../utils/util';
import './Profile.css';
import Wrapper from './Wrapper';
import {
  fetchUser,
  listRooms,
  createEscape,
  deleteEscape,
  updateEscape,
  createReview,
  getProfile,
  getSuggestions,
  createTeam,
  listReviews,
  setRank,
  listCompanies,
  addLocation,
  updateRoom,
} from '../actions';
import OzPills from './partials/OzPills';
import OzModalButton from './partials/OzModalButton';
import EscapeForm from './partials/EscapeForm';
import LocationForm from './partials/LocationForm';
import EscapeList from './partials/EscapeList';
import EscapeMap from './partials/EscapeMap';
import Ranking from './partials/Ranking';
import ReviewItem from './partials/ReviewItem';
import ReviewForm from './partials/ReviewForm';
import RoomInfo from './partials/RoomInfo';
import TeamForm from './partials/TeamForm';
import DeleteRoomForm from './partials/DeleteRoomForm';
import { PercentBar } from './partials/ReviewItem';
import EscapeStats from './partials/EscapeStats';


class Profile extends OzComponent {

  static need = [
    ['user', fetchUser],
    // ['rooms', listRooms],
    ['profile', getProfile, p => p.username],
    ['reviews', listReviews, p => { return { profile__user__username: p.username } }],
    ['companies', listCompanies, () => { return { mine: 1 } }],
  ];

  constructor(props) {
    super(props);
    let params = getParams();
    let mapSize = params.map || 'big';
    this.state ={
      addingEscape: false,
      addingTeam: false,
      expanded: {},
      mapSize: mapSize,
    };
  }

  componentDidMount() {
    let profile = this.props.profile;
    if (profile && this.props.params.username != profile.username) {
      let username = this.props.params.username;
      this.props.getProfile(username);
      this.props.listReviews({ profile__user__username: username }, { background: true });
    }
  }

  addEscape(e, values) {
    e.preventDefault();
    this.props.createEscape(values)
      .then(resp => {
        if (!resp.error) {
          this.props.getProfile(this.props.params.username, { background: true })
            .then(resp => {
              this.closeAddEscape();
              NotificationManager.success('Added the escape!');
            });
        }
      });
  }

  closeAddEscape() {
    this.setState({ addingEscape: false });
  }

  renderAddEscape() {
    return (
      <Modal show={!!this.state.addingEscape}>
        <Modal.Header closeButton onHide={() => this.closeAddEscape()}>
          <Modal.Title>Add Escape</Modal.Title>
        </Modal.Header>
        <EscapeForm
          modal={true}
          values={{}}
          errors={this.props.errors.escape}
          onSubmit={(e, values) => this.addEscape(e, values)}
          onCancel={() => this.closeAddEscape()}
          buttonText="Add"
          cancelText="Cancel"
          rooms={[]}
          getSuggestions={(...args) => this.props.getSuggestions(...args)}
          teamMemberships={this.props.profile.teamMemberships}
        />
      </Modal>
    );
  }

  addTeam(e, values) {
    e.preventDefault();
    let profile = this.props.profile;
    this.props.createTeam(values)
      .then(resp => {
        console.log('create team resp:', resp);
        if (resp.error) return;
        this.props.getProfile(profile.username, { background: true })
          .then(() => this.closeAddTeam());
      });
  }

  closeAddTeam() {
    this.setState({ addingTeam: false });
  }

  renderAddTeam() {
    return (
      <Modal show={!!this.state.addingTeam}>
        <Modal.Header closeButton onHide={() => this.closeAddTeam()}>
          <Modal.Title>Add Team</Modal.Title>
        </Modal.Header>
        <TeamForm
          modal={true}
          values={{}}
          errors={this.props.errors.team}
          onSubmit={(e, values) => this.addTeam(e, values)}
          onCancel={() => this.closeAddTeam()}
          buttonText="Create"
          cancelText="Cancel"
        />
      </Modal>
    );
  }

  renderTeams() {
    let profile = this.props.profile;
    if (!profile) return;

    let isSelf = this.props.isSelf;

    if (!profile.teamMemberships) return;

    let nodes = profile.teamMemberships.map(tm => {
      let memberNodes = tm.team.members.map(m => {
        return (
          <div className="member" key={m.id}>{m.username}</div>
        )
      });

      return (
        <div className="team" key={tm.id}>
          {/*
          <div className="controls">
            <Button
              bsSize="small"
              onClick={() => this.setState({ addingEscape: true })}
            >Add Escape with {tm.team.name}</Button>
          </div>
          */}

          <div className="name"><Link to={'/team/' + tm.team.id}>{tm.team.name}</Link></div>
          <div className="members">{memberNodes}</div>
          {tm.team.photo && <div className="photo"><img src={tm.team.photo} /></div>}
        </div>
      );
    });

    return (
      <div>
        <div>
          <div className="header-wrapper">
            <div className="header">{isSelf ? 'Your Teams' : profile.username + "'s Teams"}</div>
            {isSelf && <div className="controls"><Button
             bsStyle="primary"
             onClick={() => this.setState({ addingTeam: true })}
             >Add Team</Button></div>}
          </div>
          <div className="teams">{nodes}</div>
        </div>
      </div>
    );
  }

  refreshReviews() {
    let profile = this.props.profile;
    return this.props.listReviews({ profile__user__username: profile.username }, { background: true });
  }

  renderRanking() {
    let profile = this.props.profile;
    if (!profile) return;

    let reviews = this.props.reviews;
    if (!reviews) return;

    let isSelf = this.props.isSelf;

    return (
      <div className="rankings-wrapper">
        <div className="header-wrapper">
          <div className="header">{isSelf ? 'Your Room Ranking' : profile.username + "'s Room Ranking"}</div>
        </div>

        <p>
          The room rankings below are based on {isSelf ? 'your' : profile.username + "'s"} ratings. Room rankings are used to show a relative comparison between escape rooms. The rooms at the top of the list are always a good bet, and rooms above 70 or so are good.
        </p>
        <Ranking
          noHeader
          noFilter
          onRefresh={() => this.refreshReviews()}
          reviews={reviews}
          isSelf={this.props.isSelf}
        />
      </div>
    );
  }

  setMap(mapSize) {
    this.setState({ mapSize });
    addUrlParam({ map: mapSize });
  }

  renderUser() {
    let profile = this.props.profile;
    // if (!profile) return;

    let title = '';
    if (profile) {
      title = profile.username + "'s Profile";
    }
    let isSelf = this.props.isSelf;
    let escapes = profile ? profile.allEscapes : [];
    let escapeSummary = <EscapeStats escapes={escapes} title={title} />;

    let hasCompanies = this.props.companies && this.props.companies.items.length > 0;

    return (
      <div>
        <OzTabs header={escapeSummary}>
          <div tabKey="escapes" tabName="Escapes">
            <div className={cx('escapes-views', 'map-' + this.state.mapSize)}>
              <div className="escape-view-list">
                <EscapeList
                  isSelf={isSelf}
                  user={this.props.user}
                  profile={this.props.profile}
                  escapes={escapes}
                  username={this.props.params.username}
                />
              </div>
            </div>
          </div>
          <div tabKey="map" tabName="Map of Escapes">
            <EscapeMap
              escapes={escapes}
              mapSize={this.state.mapSize}
            />
          </div>
          <div tabKey="ranking" tabName="Room Ranking">
            {this.renderRanking()}
          </div>
          <div tabKey="teams" tabName="Teams">
            {this.renderTeams()}
          </div>
        </OzTabs>

      </div>
    );
  }

  render() {
    let profile = this.props.profile;
    let isSelf = this.props.isSelf;

    return (
      <Wrapper className="Profile" title="">
        <div className="control-buttons">
        </div>

        {/* isSelf && this.renderAddEscape() */}
        {isSelf && this.renderAddTeam()}

        {this.renderUser()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  let isSelf = false;
  let isLoading = true;

  if (state.user && state.user.profile && state.get.profile) {
    isLoading = false;
    isSelf = state.user.profile.id == state.get.profile.id;
  }

  if (state.user && !state.user.profile && state.get.profile) {
    isLoading = false;
    isSelf = false;
  }

  return {
    user: state.user,
    errors: state.errors,
    profile: state.get.profile,
    reviews: state.list.review,
    companies: state.list.company,
    isSelf,
    isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    fetchUser,
    createEscape,
    updateEscape,
    deleteEscape,
    getProfile,
    getSuggestions,
    createTeam,
    setRank,
    listReviews,
    createReview,
    listCompanies,
    addLocation,
    updateRoom,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile);



/** WEBPACK FOOTER **
 ** ./src/components/Profile.js
 **/